import { graphql, useStaticQuery } from "gatsby";

export const useHomePageQuery = () => {
  const { allStrapiHomePage } = useStaticQuery(graphql`
    query HomePageQuery {
      allStrapiHomePage {
        nodes {
          banner_section {
            banner_images {
              image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      placeholder: BLURRED
                      formats: [WEBP, AUTO]
                      quality: 85
                      breakpoints: [400, 800, 1200, 1600, 2000]
                    )
                  }
                }
              }
              mobile_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      placeholder: BLURRED
                      formats: [WEBP, AUTO]
                      quality: 80
                      breakpoints: [375, 414, 768]
                      outputPixelDensities: [1, 1.5, 2]
                    )
                  }
                }
              }
              link_redirection
              same_or_different_tab
              banner_text_1
              heading
              description_1 {
                data {
                  description_1
                }
              }
              description_2 {
                data {
                  description_2
                }
              }
              description_3 {
                data {
                  description_3
                }
              }
            }
            left_arrow {
              alternativeText
              url
            }
            right_arrow {
              alternativeText
              url
            }
          }
          tabs_section {
            title
            title_color
            watermark_1 {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP, AUTO])
                }
              }
            }
            watermark_2 {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP, AUTO])
                }
              }
            }
            bg_color
            tabs_section {
              tab_name
              cards_section {
                heading
                heading_color
                card_image {
                  alternativeText
                  url
                }
                buttons {
                  bg_color
                  href
                  icon {
                    alternativeText
                    url
                  }
                  label
                  label_color
                }
              }
            }
          }
          service_highlights {
            heading
            heading_color
            cards {
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      width: 500
                      quality: 65
                      placeholder: BLURRED
                      formats: [WEBP, AUTO]
                      breakpoints: [400, 800, 1200, 1600, 2000]
                    )
                  }
                }
              }
              heading
              description {
                data {
                  description
                }
              }
              heading_color
              card_bg_color
            }
            watermark_1 {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            watermark_2 {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
          }
          explore_section {
            heading
            heading_color
            sub_heading
            description {
              data {
                description
              }
            }
            desktop_bg {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            mobile_bg {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            button {
              bg_color
              href
              label
              label_color
              target
            }
          }
          hoi_app {
            title
            title_color
            subtitle_color
            subtitle
            description_color
            bg_color
            description {
              data {
                description
              }
            }
            app_logo {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            app_screenshot {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            app_store_button {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            google_play_button {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            play_store_link
            apple_store_link
          }
          blogs_section {
            heading
            heading_color
            watermark_1 {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            watermark_2 {
              alternativeText
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                    formats: [WEBP, AUTO]
                    quality: 90
                  )
                }
              }
            }
            cards {
              card_bg_color
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      placeholder: BLURRED
                      formats: [WEBP, AUTO]
                      quality: 85
                      breakpoints: [400, 800, 1200, 1600, 2000]
                    )
                  }
                }
              }
              heading
              card_button {
                bg_color
                href
                label
                label_color
              }
            }
          }
        }
      }
    }
  `);
  return allStrapiHomePage?.nodes[0];
};
